module.exports = __webpack_public_path__ + "static/about_wide-3c8cab35432b4fa0e9225cd6180f1628.png";